module.exports = __webpack_public_path__ + "img/Feature-2.16ee0c2.svg";